<template>
  <div class="order-wrapper">
    <div class="order_success order_success_o">
      <div class="order-result">
        <div class="get-process" v-if="!isInit">
          <p>支付结果获取中...</p>
        </div>
        <div v-else-if="res.result">
          <div>
            <img alt class="order-result-icon" src="@/assets/images/html/success_03.png">
            <div>
              <div class="order-result-msg">
                <div class="one">
                  <span>订单{{orderId}}全额支付成功！</span>
                </div>
              </div>
              <div>
                <payOrderDetail
                  :orderInfo="res.orderInfo"
                  :paidAmount="res.paidAmount"
                  :planInfo="res.planInfo"
                ></payOrderDetail>
              </div>
            </div>
            <div class="order_success_content" style="border: none;">
              <amount-detail
                :advanceList="res.advanceList"
                :favorableList="res.favorableList"
                :orderAdditionalCosts="res.orderAdditionalCosts"
                :orderInfo="res.orderInfo"
                :orderNums="res.orderNums"
                :ticketPrices="res.ticketPrices"
                :ticketType="res.ticketTypes"
              ></amount-detail>
            </div>
          </div>
        </div>
        <div class="order-result-error" v-else>
          <img alt class="order-result-icon" src="@/assets/images/html/fail.png">
          <div class="order-result-msg">
            <div class="one">
              <span>订单提交失败！{{msg}}&nbsp;请联系旅行销售客服！</span>
            </div>
            <div class="customer_service_information order-result-userinfo call_agent">
              <em class="one">销售客服</em>
              <img :src="res.user_photo_url" alt class="server_avatar">
              <em>{{res.userInfo.name}}</em>
              <a :href="'tel:' + res.userInfo.cell" class="tel">
                <img alt="电话号码" class="user-tel" src="~@/assets/images/html/call_03.png">
                <span>{{res.userInfo.cell}}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="order-result-error-button">
      <a @click="goBack()" href="javascript:void(0);">
        <span>返回</span>
      </a>
    </div>
  </div>
</template>
<script>
import { payOrderDetail } from './components/'
import { amountDetail } from '../agent/components/'
import no_photo from '@/assets/images/html/no_photo.gif'
export default {
  name: "PayResult",
  componentName: "PayResult",
  components: {
    payOrderDetail, amountDetail
  },
  data () {
    return {
      orderId: '',
      amountType: '',
      outTradeNo: '',

      msg: '',

      res: {
        orderInfo: {},
        user_photo_url: '',
        planInfo: {},
        // deposit: null,
        advanceList: [],
        favorableList: [],
        orderAdditionalCosts: [],
        orderNums: [],
        ticketTypes: [],
        ticketPrices: [],
        paidAmount: 0,
        userInfo: {},
        result: false
      },

      isInit: false, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      no_photo: no_photo,
    }
  },
  created () {
    this.orderId = this.$route.query.order_id
    this.amountType = this.$route.query.amount_type
    if (!this.orderId || !this.amountType) {
      this.$msg('参数异常', 'error') //TODO
      return
    }
    this.outTradeNo = this.$route.query.out_trade_no

    this.$myGet('pay/detail_results/' + this.orderId, { no: this.outTradeNo, modules: 'plan,structure,additional,ticket,amount,saler' }) //deposit
      .then(res => {
        this.$util.copy(res.response.data, this.res);
        this.msg = this.$sessionStorageUtil.get('payWeixin' + this.orderId);
        this.isInit = true;
      })
      .catch(err => {
        console.log('err:' + err)
      })
  },
  methods: {
    goBack () {
      this.$pushByName('routeOrderResult',
        {
          msg: '',
          is_success: true,
          _user_name: this.res.userInfo.username,
          order_info_id: this.orderId
        })
    }
  }
}
</script>
<style scoped>
.get-process {
  margin-bottom: 100px;
}
</style>


// WEBPACK FOOTER //
// src/pages/pay/payResult.vue